// extracted by mini-css-extract-plugin
module.exports = {"p_rec__title":"ProjectRecommended_p_rec__title__3tElk","p_rec__box":"ProjectRecommended_p_rec__box__3SE6g"};